var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 39,
    viewBox: "0 0 42 39",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.407 23.263l6.602-6.602 6.602 6.602m-6.601-6.604v20.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.091 27.1h-2.522c-5.284 0-9.568-4.286-9.568-9.57 0-5.286 4.284-9.57 9.568-9.57h.938C12.645 3.944 16.631 1 21.009 1c5.286 0 9.57 4.284 9.57 9.568h2.176a8.266 8.266 0 0 1 8.264 8.266c0 4.564-3.7 8.266-8.264 8.266h-3.37"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e68395cb0a389f82101ca42011fed782.svg";
export { ForwardRef as ReactComponent };